// src/navigation/wrappers/VisitorNavigationWrapper.jsx
import React from 'react';
import VisitorNav from '../../components/VisitorNav';
import VisitorTopMenuBar from '../../components/VisitorTopMenuBar';
import VisitorMobileBottomNav from '../../components/VisitorMobileBottomNav';
import VisitorFooter from '../../components/VisitorFooter';

const VisitorNavigationWrapper = ({ children }) => {
  return (
    <>
      <VisitorNav />
      <VisitorTopMenuBar />
      {children}
      <VisitorMobileBottomNav />
      <VisitorFooter />
    </>
  );
};

export default VisitorNavigationWrapper;
